export default __webpack_public_path__ + "static/media/view1_year_country.6a1f6790.csv";